import React, { PropTypes as p } from 'react'

const MarkerIcon = ({
  color,
  ...rest
}) => (
  <div className='marker-icon' {...rest}>
    <svg width='14px' height='20px' viewBox='0 0 14 20'>
      <path id='marker-icon' fill={color} d='M7,0 C3.13,0 0,3.13 0,7 C0,12.25 7,20 7,20 C7,20 14,12.25 14,7 C14,3.13 10.87,0 7,0 L7,0 Z M7,9.5 C5.62,9.5 4.5,8.38 4.5,7 C4.5,5.62 5.62,4.5 7,4.5 C8.38,4.5 9.5,5.62 9.5,7 C9.5,8.38 8.38,9.5 7,9.5 L7,9.5 Z'></path>
    </svg>
  </div>
)

MarkerIcon.propTypes = {
  color: p.string.isRequired
}

export default MarkerIcon



// WEBPACK FOOTER //
// ./src/components/pins/marker-icon.js